import types from './types';
import { serviceActions } from 'state/modules/service';
import * as dataEntity from 'graphql/DataEntity';

export function saveCustomMenu(screenReference, sortOrder, folder, id) {
  var requestBody = {
    screenReference: screenReference,
    sortOrder: sortOrder,
    folder: folder,
  };
  if (id) {
    requestBody.id = id.id;
    requestBody.concurrencyVersion = id.concurrencyVersion;
  }
  return function(dispatch, getState) {
    return dispatch(() =>
      dispatch(serviceActions.saveInstance('Added to menu', dataEntity.SYSTEM_SCREEN, requestBody, 'menu'))
    ).then(
      () => {
        if (getState().data.alert.type === 'success') {
          let instance = getState().data.instance.menu;
          dispatch(serviceDataToMenu(dataEntity.SYSTEM_SCREEN));
        }
      },
      reason => {}
    );
  };
}

export function deleteCustomMenu(option, menuType, id) {
  return function(dispatch, getState) {
    dispatch(() => dispatch(deleteMenuItem(option)));
    let newList = [];
    let newFList = [];

    let list = getState().menu.menu;
    let listKeys = Object.keys(list);
    let fList = Object.keys(getState().menu.folders).length !== 0 ? getState().menu.folders : {};
    let fListKeys = Object.keys(fList);
    for (let i = 0; i < listKeys.length; i++) {
      newList.push(list[listKeys[i]]);
    }
    for (let k = 0; k < fListKeys.length; k++) {
      newFList.push(fList[fListKeys[k]]);
    }
    dispatch(
      saveBulkCustomMenu({
        list: newList,
        fList: newFList,
        deletedType: menuType,
        deletedId: id,
      })
    );
  };
}

export function requestCustomMenu() {
  return function(dispatch, getState) {
    return dispatch(() =>
      dispatch(
        serviceActions.requestList(dataEntity.SYSTEM_SCREEN, 'menu', {
          sortBy: 'sortOrder',
          sortDir: 'ASC',
          filters: [
            {
              fieldName: 'systemUser.id',
              operation: '=',
              value: getState().app.user.id,
            },
          ],
        })
      )
    ).then(
      () => {
        let list = getState().data.list.menu;
        dispatch(serviceListToMenu(dataEntity.SYSTEM_SCREEN));
      },
      reason => {}
    );
  };
}

export function saveBulkCustomMenu(data) {
  return function(dispatch, getState) {
    return dispatch(() => dispatch(serviceActions.saveCustomMenu(newMenu))).then(
      () => {
        let list = getState().data.list;
        dispatch(serviceBulkToMenu(data));
      },
      reason => {}
    );
  };
}

export function requestCustomFolders() {
  return function(dispatch, getState) {
    return dispatch(() =>
      dispatch(
        serviceActions.requestList(dataEntity.SYSTEM_FOLDER, 'folders', {
          filters: [
            {
              fieldName: 'systemUser.id',
              operation: '=',
              value: getState().app.user.id,
            },
          ],
        })
      )
    ).then(
      () => {
        let list = getState().data.list.folders;
        if (list && !list.isLoading) dispatch(serviceListToFolder(dataEntity.SYSTEM_FOLDER));
      },
      reason => {}
    );
  };
}

export function updateFolderName(requestBody) {
  return {
    formKey: 'folders',
    type: types.CHANGE_FOLDER_NAME,
    requestBody: requestBody,
  };
}

export function serviceDataToMenu(data) {
  return {
    formKey: dataEntity.SYSTEM_SCREEN,
    type: types.SERVICE_DATA_TO_MENU,
    data: data,
  };
}

export function serviceListToMenu(data) {
  return {
    formKey: dataEntity.SYSTEM_SCREEN,
    type: types.SERVICE_LIST_TO_MENU,
    data: data,
  };
}

export function serviceBulkToMenu(data) {
  return {
    formKey: dataEntity.SYSTEM_SCREEN,
    data: data,
    type: types.SERVICE_BULK_TO_MENU,
  };
}

export function serviceDataToFolder(data) {
  return {
    formKey: dataEntity.SYSTEM_FOLDER,
    type: types.SERVICE_DATA_TO_FOLDER,
    data: data,
  };
}

export function serviceListToFolder(data) {
  return {
    formKey: dataEntity.SYSTEM_FOLDER,
    type: types.SERVICE_LIST_TO_FOLDER,
    data: data,
  };
}

export function deleteMenuItem(data) {
  return {
    type: types.DELETE_MENU_ITEM,
    data: data,
  };
}

export default {
  updateFolderName,
  serviceDataToMenu,
  serviceListToMenu,
  serviceBulkToMenu,
  serviceDataToFolder,
  serviceListToFolder,
  deleteMenuItem,
};
